import * as React from 'react';

import { ShowMoreList } from '@coursera/cds-core';
import type { ShowMoreListProps } from '@coursera/cds-core';

import type { FaqProps } from 'bundles/cms/types';
import Faq from 'bundles/design-system/components/Faq';
import FaqsSchemaMarkup from 'bundles/seo/components/FaqsSchemaMarkup';

import 'css!bundles/design-system/components/__styles__/Faqs';

// Show only top three FAQs https://coursera.atlassian.net/browse/ACQU-1457
const DEFAULT_FAQS_TO_SHOW = 3;

type Props = {
  faqs?: Array<FaqProps | null>;
  isBrowsePage?: boolean;
  enableShowMoreList?: boolean;
  showMoreListProps?: Partial<ShowMoreListProps>;
};

function Faqs({ faqs, isBrowsePage, enableShowMoreList, showMoreListProps }: Props) {
  if (!faqs || !faqs.length) {
    return null;
  }

  const faqList = faqs.map((faq, idx) => {
    if (!faq || !faq.question || !faq.answer) {
      return null;
    }

    return (
      <Faq
        key={faq.question}
        faq={faq}
        index={idx}
        isBrowsePage={isBrowsePage}
        component={enableShowMoreList ? 'div' : 'li'}
      />
    );
  });

  return (
    <div className="rc-Faqs">
      <FaqsSchemaMarkup faqs={faqs} />
      {enableShowMoreList ? (
        <ShowMoreList className="faqList" numItemsToShow={DEFAULT_FAQS_TO_SHOW} {...showMoreListProps}>
          {faqList}
        </ShowMoreList>
      ) : (
        <ul className="faqList">{faqList}</ul>
      )}
    </div>
  );
}

export default Faqs;
